import { request } from '@/services/request';
import type { ReplyData, ReqParams } from '@/pages/api/device/unbindAllDevice';

export function unbindAllDevice(params: ReqParams): Promise<ReplyData> {
  return request({
    method: 'post',
    url: '/api/device/unbindAllDevice',
    data: params,
  }).then((res) => res.data);
}
